/**
 * Composition service to serve template data for endpoints
 * 
 * Author: Sahil David <sahil.david@huumun.com>
 */
import { getLyraEndpoints } from '@/core/modules/lyra/services';
import { inject } from 'vue';

import TemplateLibrary from '../components/template-library.vue';
import TemplateNotFound from '../components/template-not-found.vue';

export function templateEndpointComposition () {
	// Injecting endpoint data
	const endpointData = inject<any>('endpointData');

	// Return active template required for endpoint
	function activeTemplate () {
        // TODO: template should be coming from template folder rather than lyra because it removes the dependency
        const lyraTemplates = getLyraEndpoints('template');
        const { template } = endpointData.value;
		
        const existTemplate = lyraTemplates.find((_) => _.endpointId === template);
		return existTemplate ? TemplateLibrary : TemplateNotFound;
    }

	return { activeTemplate };
}